import { makeRequest } from 'utils/requestLogger';

const joinWithCode = (invite_code) =>
  makeRequest('post', `/api/invites/join`, { invite_code });

const validateCode = (invite_code) =>
  makeRequest('post', `/api/invites/validate`, { invite_code });

const getEmailSuffixesOfSchool = (code) =>
  makeRequest('get', `/api/invites/${code}/email_suffixes`);
export default {
  joinWithCode,
  validateCode,
  getEmailSuffixesOfSchool
};



// WEBPACK FOOTER //
// ./src/app/services/invites/index.js